var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-bg"},[_vm._m(0),_vm._m(1),_c('i-nav')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../assets/logo.png"),"alt":""}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-guide-page"},[_c('div',[_c('img',{attrs:{"src":require("../assets/task-guide-2026.jpg"),"alt":""}})])])
}]

export { render, staticRenderFns }